import { createSlice } from "@reduxjs/toolkit";
import { fulfilled, idle } from "features/status";

const initialState = {
  dashboard: {
    status: idle,
    quotes: 0,
    authors: 0,
    topics: 0,
    users: 0,
  },
  statuses: [
    { value: "Draft", label: "Draft" },
    { value: "Pending", label: "Pending" },
    { value: "Published", label: "Published" },
  ],
  authors: {
    items: [],
    status: idle,
  },
  loaded: false,
};

export const cmsSlice = createSlice({
  name: "cms",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    testAction: (state) => {
      state.loaded = true;
    },
    loadAuthors: (state, action) => {
      state.authors.items = action.payload.items;
      state.authors.status = fulfilled;
    },
    loadDashboard: (state, action) => {
      state.dashboard = { ...action.payload, status: fulfilled };
    },
  },
});

export const { testAction, loadAuthors, loadDashboard } = cmsSlice.actions;

export const selectCMS = (state) => state.cms;

// export default cmsSlice.reducer;
